const formInitPromo = {
  title: "",
  promoType: "promo_to_item",
  description: "",
  budget: "",
  budgetUnit: "",
  budgetSpend: "",
  budgetBy: "",
  mailingNumber: "",
  priority: 0,
  isActive: true,
  startDatetime: "",
  endDatetime: "",
  promoTargetItem: {
    target: {
      targetType: "",
      item: [],
      kategori: "",
      brand: "",
      principal: ""
    },
    boundary: {
      boundaryType: [],
      uom: "",
      qty: {
        min: "",
        max: ""
      },
      value: {
        min: "",
        max: ""
      },
      paymentMethod: "",
      customerClass: "",
      customerType: "",
      rgm: "",
      branch: "",
      regionIdn: "",
      oracleCustomerId: "",
      province: "",
      regency: "",
      district: "",
    },
    promoValue: {
      promoValueType: "",
      discount: {
        value: "",
        max: ""
      },
      priceCut: {
        value: "",
        max: ""
      },
      point: {
        value: "",
        max: ""
      },
      freeItem: {
        oracleItemId: "",
        qty: ""
      }
    }
  },
  promoTargetPaymentMethod: {
    target: {
      targetType: "paymentCode",
      paymentCode: ""
    },
    promoValue: {
      promoValueType: "",
      discount: {
        value: "",
        max: ""
      },
      priceCut: {
        value: "",
        max: ""
      },
      point: {
        value: "",
        max: ""
      },
      freeItem: {
        oracleItemId: "",
        qty: ""
      }
    }
  },
  promoTargetCart: {
    target: {
      targetType: "",
      oracleCustomerId: [],
      rgm: "",
      branch: "",
      customerClass: "",
      customerType: ""
    },
    boundary: {
      boundaryType: [],
      uom: "",
      qty: {
        min: "",
        max: ""
      },
      value: {
        min: "",
        max: ""
      },
      paymentMethod: "",
      customerClass: "",
      customerType: "",
      rgm: "",
      branch: "",
      regionIdn: "",
      province: "",
      regency: "",
      district: "",
    },
    promoValue: {
      promoValueType: "",
      discount: {
        value: "",
        max: ""
      },
      priceCut: {
        value: "",
        max: ""
      },
      point: {
        value: "",
        max: ""
      },
      freeItem: {
        oracleItemId: "",
        qty: ""
      }
    }
  },
  promoTargetStrata: {
    target: {
      targetType: "",
      item: [],
      kategori: "",
      brand: "",
      principal: ""
    },
    boundary: {
      boundaryType: ["branch"],
      branch: "",
      province: "",
      regency: "",
      district: "",
    },
    promoValue: {
      promoValueType: "strata",
      strata: [
        {
          discountValue: "",
          limit: ""
        }
      ],
      strataPriceCut: [
        {
          priceCutValue: "",
          limit: ""
        }
      ]
    }
  },
  voucher: {
    voucherCode: "",
    boundary: {
      boundaryType: [],
      uom: "",
      qty: {
        min: "",
        max: ""
      },
      value: {
        min: "",
        max: ""
      },
      paymentMethod: "",
      customerClass: "",
      customerType: "",
      rgm: "",
      branch: "",
      regionIdn: "",
      multiOracleCustomerId: [],
      province: "",
      regency: "",
      district: "",
    },
    promoValue: {
      promoValueType: "",
      discount: {
        value: "",
        max: ""
      },
      priceCut: {
        value: "",
        max: ""
      }
    }
  },
  promoTargetPushCart: {
    target: {
      targetType: "",
      oracleItemId: "",
    },
    boundary: {
      boundaryType: [],
      customerClass: "",
      customerType: "",
    },
    promoValue: {
      promoValueType: "",
      discount: {
        value: "",
        max: ""
      },
    }
  },
  createdBy: ""
};

export { formInitPromo };
